import country from './field-country';
import email from './field-email';
import feedbackConsent from './field-feedback-consent';
import firstname from './field-firstname';
import lastname from './field-lastname';
import marketingConsent from './field-marketing-consent';
import starRating from './field-star-rating';
import stateCA from './field-state-ca';
import stateUS from './field-state-us';
import submitConfirmation from './submit-confirmation';
import thankyouMessage from './thankyou-message';

export default {
    country,
    email,
    feedbackConsent,
    firstname,
    lastname,
    marketingConsent,
    starRating,
    stateCA,
    stateUS,
    submitConfirmation,
    thankyouMessage
}
